"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigAccordionDetails = exports.ConfigAccordionSummary = exports.ConfigAccordion = void 0;
const core_1 = require("@material-ui/core");
exports.ConfigAccordion = (0, core_1.withStyles)(theme => ({
    root: {
        boxShadow: 'none',
        marginBottom: -1,
        '&:before': {
            display: 'none'
        },
        '&$expanded': {
            margin: '0',
            borderLeft: `solid 4px ${theme.palette.primary.main};`
        },
        '&.dragging': {
            opacity: 0.7,
            borderRadius: '4px',
            boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)'
        }
    },
    expanded: {}
}))(core_1.Accordion);
exports.ConfigAccordionSummary = (0, core_1.withStyles)({
    root: {
        minHeight: 0,
        borderTop: 'solid 1px #ccc',
        borderBottom: 'solid 1px #ccc',
        '&:hover': {
            background: '#f4f4f4'
        },
        '&$expanded': {
            minHeight: 0,
            background: '#f4f4f4'
        }
    },
    focused: {
        backgroundColor: 'none !important'
    },
    content: {
        alignItems: 'center',
        '&$expanded': {
            margin: '12px 0'
        },
        '& .drag-indicator': {
            marginLeft: '-12px',
            color: '#ccc'
        }
    },
    expandIcon: {
        marginRight: '-4px !important',
        transform: 'none !important'
    },
    expanded: {
        minHeight: 0
    }
})(core_1.AccordionSummary);
exports.ConfigAccordionDetails = (0, core_1.withStyles)({
    root: {
        display: 'flex',
        flexDirection: 'column',
        padding: 0
    }
})(core_1.AccordionDetails);
//# sourceMappingURL=ConfigAccordion.js.map